
import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import HeroSection from './components/HeroSection';
import PackagesGrid from './components/PackagesGrid';
import WhyChooseUs from './components/WhyChooseUs';
import IncludedServices from './components/IncludedServices';
import BookingProcess from './components/BookingProcess';
import FAQ from './components/FAQ';

export default function UmrahHajjPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.alwaz.travel';
    const scripts: HTMLScriptElement[] = [];

    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'Umrah & Hajj Packages from UK | Alwaz Travels London',
        description: 'Book affordable Umrah and Hajj packages from the UK with Alwaz Travels. All-inclusive packages with flights, hotels near Haram, visa, and guided tours. WhatsApp +44 7362 505895.',
        url: `${siteUrl}/umrah-hajj`,
        isPartOf: { '@type': 'WebSite', name: 'Alwaz Travels', url: siteUrl },
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
            { '@type': 'ListItem', position: 2, name: 'Umrah & Hajj', item: `${siteUrl}/umrah-hajj` },
          ],
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Umrah & Hajj Packages',
        provider: {
          '@type': 'TravelAgency',
          name: 'Alwaz Travels',
          url: siteUrl,
          telephone: '+442034884455',
          address: { '@type': 'PostalAddress', addressLocality: 'London', addressCountry: 'GB' },
        },
        description: 'All-inclusive Umrah and Hajj packages from the UK including flights, accommodation near Haram, visa processing, and guided spiritual tours.',
        areaServed: { '@type': 'Country', name: 'United Kingdom' },
        hasOfferCatalog: {
          '@type': 'OfferCatalog',
          name: 'Umrah & Hajj Packages',
          itemListElement: [
            { '@type': 'Offer', name: 'Economy Umrah Package', description: 'Budget-friendly Umrah package with 3-star hotel near Haram' },
            { '@type': 'Offer', name: 'Standard Umrah Package', description: 'Comfortable Umrah package with 4-star hotel and guided tours' },
            { '@type': 'Offer', name: 'Premium Umrah Package', description: 'Luxury Umrah experience with 5-star hotel steps from Masjid al-Haram' },
            { '@type': 'Offer', name: 'Hajj Package', description: 'Complete Hajj package with all logistics, accommodation, and spiritual guidance' },
          ],
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'What is included in your Umrah packages from the UK?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Our Umrah packages include return flights from the UK, hotel accommodation near Masjid al-Haram in Makkah and Masjid an-Nabawi in Madinah, Umrah visa processing, airport transfers, and optional guided ziyarat tours.',
            },
          },
          {
            '@type': 'Question',
            name: 'How much does an Umrah package cost from London?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Umrah packages from London start from approximately £799 per person for economy packages. Premium packages with 5-star hotels near Haram can range from £1,500 to £3,000+ per person. Contact Alwaz Travels on WhatsApp for the latest prices.',
            },
          },
          {
            '@type': 'Question',
            name: 'Do you offer group Umrah packages for families?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Yes, Alwaz Travels specialises in family and group Umrah packages with special discounts for groups of 10 or more. We also offer Ramadan Umrah packages and custom departure dates.',
            },
          },
        ],
      },
    ];

    schemas.forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
      scripts.push(script);
    });

    document.title = 'Umrah & Hajj Packages from UK | Alwaz Travels London';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', 'Book affordable Umrah and Hajj packages from the UK with Alwaz Travels London. All-inclusive packages with flights, hotels near Haram, visa, and guided tours. Get a quote on WhatsApp.');

    return () => {
      scripts.forEach((s) => s.parentNode?.removeChild(s));
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <PackagesGrid />
      <IncludedServices />
      <WhyChooseUs />
      <BookingProcess />
      <FAQ />
      <Footer />
    </div>
  );
}
